module.exports = __webpack_public_path__ + "img/myphone_shop_banner_3.c1997626.jpeg";